import { render, staticRenderFns } from "./standardSwitch.vue?vue&type=template&id=0f736c02&scoped=true&"
import script from "./standardSwitch.vue?vue&type=script&lang=js&"
export * from "./standardSwitch.vue?vue&type=script&lang=js&"
import style0 from "./standardSwitch.vue?vue&type=style&index=0&id=0f736c02&lang=scss&scoped=true&"
import style1 from "./standardSwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f736c02",
  null
  
)

export default component.exports